
import { ConsumeTokenRequest, EmployeeCodesRequest, EmployeeFreebiesAssignRequest, EmployeeFreebiesResponse, EmployeeTokenConsumptionReportRequest, EmployeeTokenConsumptionReportResponse, SummaryReportRequest, SummaryReportResponse, TokenPrintModel, TokenPrintResponse, FreebieIdRequest } from '@gtpl/shared-models/canteen-management';
import { CommonResponse } from '@gtpl/shared-models/masters';
import axios from 'axios';
import connection from './connection';

export class FreebiesMappingConsumptionService {
    URL = connection.DEPLOY_URL + '/freebies-mapping-consumption'

    async createEmployeeFreebies(empFreebiesReq: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        return await axios.post(this.URL + '/createEmployeeFreebies', empFreebiesReq)
            .then(res => {
                return res.data
            })
    }

    async createToken(empFreebiesReq: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        return await axios.post(this.URL + '/createToken', empFreebiesReq)
            .then(res => {
                return res.data
            })
    }


    async updateEmployeeFreebies(empFreebiesReq: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        return await axios.post(this.URL + '/updateEmployeeFreebies', empFreebiesReq)
            .then(res => {
                return res.data
            })
    }

    async ActivateorDeactivateToken (empFreebiesReq: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        return await axios.post(this.URL + '/ActivateorDeactivateToken', empFreebiesReq)
            .then(res => {
                return res.data
            })
        }

    async getEmployeeFreebies(employeeCodesReq: EmployeeCodesRequest): Promise<EmployeeFreebiesResponse> {
        return await axios.post(this.URL + '/getEmployeeFreebies', employeeCodesReq)
            .then(res => {
                return res.data
            })
    }

    async getAllEmployeeFreebies(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllEmployeeFreebies')
            .then(res => {
                return res.data
            })
    }

    async deleteEmployeeFreebies(employeeCodesReq: EmployeeCodesRequest): Promise<EmployeeFreebiesResponse> {
        return await axios.post(this.URL + '/deleteEmployeeFreebies', employeeCodesReq)
            .then(res => {
                return res.data
            })
    }

    async consumeToken(consumeTokenRequest: ConsumeTokenRequest): Promise<TokenPrintResponse> {
        return await axios.post(this.URL + '/consumeToken', consumeTokenRequest)
            .then(res => {
                return res.data
            })
    }

    async getEmployeeTokenConsumptionReport(empTokenConsReportReq: EmployeeTokenConsumptionReportRequest): Promise<EmployeeTokenConsumptionReportResponse> {
        return await axios.post(this.URL + '/getEmployeeTokenConsumptionReport', empTokenConsReportReq)
            .then(res => {
                return res.data
            })
    }

    async getTokenConsumptionSummaryReport(summaryReportReq: SummaryReportRequest): Promise<SummaryReportResponse> {
        return await axios.post(this.URL + '/getTokenConsumptionSummaryReport', summaryReportReq)
            .then(res => {
                return res.data
            })
    }

    async checkEmployeewithfrbId(freebieId: FreebieIdRequest): Promise<boolean> {
        return await axios.post(this.URL + '/checkEmployeewithfrbId', freebieId)
            .then(res => {
                return res.data
            })
    }
}